import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 30px;

  & .ant-typography {
    margin-bottom: 0.5em;
  }
  & label > span {
    font-weight: normal;
  }
`;

export const IndentedWrapper = styled.div`
  margin-left: 10px;
`;

export const Header = styled.h3`
  margin: 35px 0 0.5em;
  padding: 0 0 8px;
  font-size: 18px;
  font-weight: 500;
  border-bottom: solid 1px #000000;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  max-width: 350px;
  margin: 0.5em 0;
`;

export const AllCarriersSection = styled.div`
  display: flex;
  justify-content: space-between;
`;
